import { StyleSheet } from "react-native";
import { AppTheme } from "../../../theme";

export const productListStyle = (theme: AppTheme) => StyleSheet.create({
    containerView: {
        flex: 1,
        backgroundColor: "#f8f8f8"
    },
    searchView: {
        marginHorizontal: 7,
        marginTop: 10
    },
    buttonContainerStyle: {
        marginHorizontal: 5,
        marginTop: 13
    },
    buttonTitleStyle: {
        fontSize: theme.mediumFontSize,
        fontFamily: theme.bold
    },
    iconView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'center',
        borderWidth: 1,
        borderRadius: 7,
        paddingHorizontal: 10,
        paddingVertical: 7,
        borderColor: theme.lightGrey,
        marginHorizontal: 5
    },
    iconTextStyle: {
        fontFamily: theme.bold,
        fontSize: theme.smallHeaderFontSize
    },
    iconStyle: {
        color: theme.grey,
        paddingRight: 5
    },
    cardContainer: {
        flex: 1,
        borderRadius: 8,
        marginBottom: 5
    },
    nameViewStyle: {
        paddingHorizontal: 10,
    },
    badgeStyle: {
        backgroundColor: '#ffedbd',
    },
    textStyle: {
        fontFamily: theme.bold,
        fontSize: theme.badgeFontSize,
        color: theme.lightDark,
    },
    containerStyle: {
        justifyContent: 'center',
        alignSelf: 'flex-start',
        marginVertical: 15
    },
    actionViewStyle: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignSelf: 'center',
        flex: 0.15
    },
    priceView: {
        justifyContent: 'center',
        alignSelf: 'flex-end',
        margin: 10
    },
    actionView: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignSelf: 'flex-end',
        flex: 0.15,
    },
    editIcon: {
        borderWidth: 1,
        borderRadius: 11,
        paddingHorizontal: 10,
        paddingVertical: 2,
        borderColor: theme.light,
        backgroundColor: theme.lightBackgroundColor
    },
    deleteIcon: {
        borderWidth: 1,
        borderRadius: 11,
        padding: 8,
        marginHorizontal: 2,
        borderColor: theme.light,
        backgroundColor: theme.lightBackgroundColor
    },
    iconBorderStyle: {
        borderWidth: 1,
        borderRadius: 11,
        width: 40,
        height: 40,
        margin: 3,
        padding: 3,
        borderColor: theme.light,
        backgroundColor: theme.lightBackgroundColor
    },
    filterHeaderStyle: { flexDirection: 'row', marginVertical: 5, justifyContent: 'flex-end' },
    filterContainer: { marginVertical: 10, marginHorizontal: 15, borderRadius: 16 },
    textStyle1: {
        fontSize: theme.smallFontSize, fontFamily: theme.bold, paddingHorizontal: 5,
    },
    filterFooterStyle: {
        flexDirection: 'row', marginVertical: 5, marginHorizontal: 10, justifyContent: "space-between", alignSelf: 'flex-end', zIndex: -1
    },
    buttonStyle: { width: 100, borderRadius: 7, backgroundColor: theme.light, borderColor: theme.primary, },
    titleStyle: { color: theme.primary, fontFamily: theme.bold, fontSize: theme.mediumFontSize },
    listContainer: {
        flexDirection: 'row', flex: 1,
        borderRadius: 8,
        marginHorizontal: 20,
        marginVertical: 10,
        padding: 20,
        backgroundColor: theme.light
    },
    searchContainer: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginHorizontal: 10,
        gap: 10,
        marginVertical: 8,
        alignItems: "center"
    },
    searchBarWrapper: {
        flex: 1
    },
    headerRightContainer: {
        flexDirection: "row",
        alignItems: "center",
        columnGap: 10
    },
    iconButton: {
        padding: 10,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: theme.borderColor,
        backgroundColor: theme.light,
        justifyContent: "center",
        alignItems: "center",
        minHeight: 44,
        minWidth: 44,
    },
    addProductBtn: {
        backgroundColor: theme.primary,
        borderRadius: 12,
        paddingHorizontal: 16,
        justifyContent: "center",
        alignItems: "center",
        shadowColor: theme.primary,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.15,
        shadowRadius: 4,
        elevation: 3,
    },
    fabButton: {
        position: "absolute",
        width: 56,
        height: 56,
        borderRadius: 28,
        bottom: 20,
        right: 20,
        justifyContent: "center",
        alignItems: "center",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 3 },
        shadowOpacity: 0.2,
        shadowRadius: 5,
        elevation: 5,
    },
    renderItemContainer: {
        flex: 1,
        marginBottom: 12,
        // marginHorizontal: 8,
        elevation: 2,
        padding: 12,
        borderRadius: 16,
        backgroundColor: theme.light,
        borderWidth: 1.5,
        borderColor: "transparent",
        shadowColor: "#000",
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.05,
        shadowRadius: 8,
    },
    renderItemContainerSelected: {
        borderColor: theme.primary,
        backgroundColor: "#F4FAFC",
    },
    itemInnerRow: {
        flex: 1,
        justifyContent: "space-between",
        flexDirection: "row"
    },
    itemLeftCol: {
        flex: 1,
        columnGap: 12,
        flexDirection: "row",
        alignItems: "center"
    },
    itemImageRow: {
        flex: 1,
        paddingVertical: 4,
        flexDirection: "row",
        alignItems: "center",
        columnGap: 12
    },
    itemImage: {
        width: 75,
        height: 75,
        borderRadius: 12,
        backgroundColor: theme.lightBackgroundColor,
        borderWidth: 1,
        borderColor: theme.borderColor,
    },
    itemDetailContainer: {
        flex: 1,
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between"
    },
    itemTextContainer: {
        rowGap: 6,
        flex: 1
    },
    itemActionContainer: {
        flexDirection: "row",
        alignItems: "center",
        columnGap: 10,
        marginLeft: 10,
    },
    actionButtonView: {
        padding: 10,
        backgroundColor: theme.lightBackgroundColor,
        borderRadius: 22,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(0, 83, 116, 0.08)",
    },
    actionButtonEdit: {
        padding: 10,
        backgroundColor: theme.tealPrimary,
        borderRadius: 22,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(0, 171, 171, 0.08)",
    },
    actionButtonDelete: {
        padding: 10,
        backgroundColor: "#FEF2F2",
        borderRadius: 22,
        justifyContent: "center",
        alignItems: "center",
        borderWidth: 1,
        borderColor: "rgba(215, 44, 12, 0.08)",
    },
    listFooterLoader: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
    },
    selectAllHeader: {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
    },
    selectAllLeft: {
        paddingHorizontal: 10,
        flexDirection: "row",
        alignItems: "center",
        flex: 1
    },
    searchBarContainer: {
        backgroundColor: theme.light,
        paddingHorizontal: 10,
        borderRadius: 20,
        height: 48,
        borderWidth: 1,
        borderColor: theme.borderColor,
    },
    searchInput: {
        color: theme.lightDark,
        fontSize: theme.smallFontSize,
        fontFamily: theme.medium,
        paddingLeft: 15
    },
    checkBoxContainer: {
        margin: 0,
        padding: 0,
        backgroundColor: "transparent"
    },
    badgeContainer: {
        position: "absolute",
        right: -7,
        top: -7,
        paddingHorizontal: 7
    },
    addProductBtnTitle: {
        fontSize: theme.mediumFontSize,
        fontFamily: theme.bold,
        color: theme.light,
    },
    cardPressed: {
        transform: [{ scale: 0.98 }],
        backgroundColor: '#FAFAFA',
    },
})